import React from 'react';
import type { ReactNode } from 'react';
import { Header } from '@brz-components/header/header';
import { Footer } from '@brz-components/footer/footer';
import { usePage } from '@brz-utils/contexts/page.context';


type PageLayoutProps = {
    children: ReactNode | ReactNode[];
};

export const PageLayout = (props: PageLayoutProps) => {
    const { template } = usePage();

    return <>
        {/* Header */}
        {template.disable?.navigation ? null : (
            <Header />
        )}
        

        {/* Content */}
        <main>
            { props.children }
        </main>


        {/* Footer */}
        <Footer />
    </>
};